import { render } from "./HomeTemplate.vue?vue&type=template&id=0470b8fc&scoped=true"
import script from "./HomeTemplate.vue?vue&type=script&lang=js"
export * from "./HomeTemplate.vue?vue&type=script&lang=js"

import "./HomeTemplate.vue?vue&type=style&index=0&id=0470b8fc&scoped=true&lang=css"

import exportComponent from "F:\\Users\\Sahar\\Desktop\\Super Tactico - Official App\\Online - Routed\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0470b8fc"]])

export default __exports__